export { default } from "./AdminConsoleFacultyAdderDistrictAdminSection";
